import React, { type FC, type PropsWithChildren } from 'react';

import { isBrowser } from '@lucid/utils';

import ABTest from '../../ab-test/ab-test';
import type { Lucid } from '../../../types/types';

export interface ABTestEnterpriseRedirectProps {
  willTriggerFire?: boolean;
  redirectPage: 'enterprise' | 'sales';
}

const ABTestEnterpriseRedirect: FC<PropsWithChildren<ABTestEnterpriseRedirectProps>> = ({
  willTriggerFire,
  redirectPage,
}) => {
  const Redirect: FC<{ branch: Lucid.ABTest.VariationKeys }> = ({ branch }) => {
    let redirectPath: string | undefined = undefined;

    if (redirectPage === 'enterprise') redirectPath = '/enterprise';

    if (redirectPage === 'sales' && branch === 'T_C') redirectPath = '/contact/contact-sales';

    if (isBrowser() && willTriggerFire && redirectPath) {
      window.location.replace(`http://lucid.co${redirectPath}`);
    }

    return null;
  };

  return (
    <ABTest
      isAboveTheFold
      branchesToRender={['T_A', 'T_B', 'T_C']}
      testName="FY25_LucidSuiteEnterpriseRedirects"
      willTriggerFire={willTriggerFire}
    >
      <ABTest.Context.Consumer>
        {({ branch }) => ['T_B', 'T_C'].includes(branch) && <Redirect branch={branch} />}
      </ABTest.Context.Consumer>
    </ABTest>
  );
};

export default ABTestEnterpriseRedirect;
